var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 26,
    viewBox: "0 0 58 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0001 14.401C58.0001 10.2997 56.0023 7.06348 52.184 7.06348C48.3495 7.06348 46.0295 10.2997 46.0295 14.369C46.0295 19.1912 48.7684 21.6264 52.6995 21.6264C54.6168 21.6264 56.0668 21.1938 57.1623 20.5851V17.3809C56.0668 17.9256 54.8101 18.262 53.2151 18.262C51.6523 18.262 50.2668 17.7173 50.0895 15.8269H57.9679C57.9679 15.6186 58.0001 14.7855 58.0001 14.401ZM50.0412 12.879C50.0412 11.0687 51.1529 10.3157 52.1679 10.3157C53.1507 10.3157 54.1979 11.0687 54.1979 12.879H50.0412Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8109 7.06348C38.2321 7.06348 37.2171 7.80044 36.6532 8.3131L36.4437 7.31981H32.8993V26.0001L36.9271 25.151L36.9432 20.6171C37.5232 21.0336 38.3771 21.6264 39.7948 21.6264C42.6787 21.6264 45.3048 19.3194 45.3048 14.2408C45.2887 9.59477 42.6304 7.06348 39.8109 7.06348ZM38.8443 18.1018C37.8937 18.1018 37.3298 17.7654 36.9432 17.3488L36.9271 11.4051C37.3459 10.9405 37.9259 10.6201 38.8443 10.6201C40.3104 10.6201 41.3254 12.2542 41.3254 14.353C41.3254 16.4997 40.3265 18.1018 38.8443 18.1018Z",
    fill: "#635BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3567 6.11735L31.4006 5.25223V2L27.3567 2.8491V6.11735Z",
    fill: "#635BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4006 7.33643H27.3567V21.3546H31.4006V7.33643Z",
    fill: "#635BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0228 8.52155L22.7651 7.33601H19.2851V21.3542H23.3128V11.8539C24.2634 10.6203 25.8745 10.8446 26.374 11.0208V7.33601C25.8584 7.14376 23.9734 6.7913 23.0228 8.52155Z",
    fill: "#635BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9673 3.85791L11.0361 4.69099L11.02 17.5237C11.02 19.8948 12.8084 21.641 15.1928 21.641C16.5139 21.641 17.4806 21.4007 18.0123 21.1123V17.8601C17.4967 18.0684 14.9511 18.8053 14.9511 16.4343V10.7469H18.0123V7.33443H14.9511L14.9673 3.85791Z",
    fill: "#635BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07612 11.4051C4.07612 10.7802 4.59167 10.5399 5.44556 10.5399C6.67001 10.5399 8.21667 10.9084 9.44112 11.5653V7.80038C8.1039 7.27169 6.78278 7.06342 5.44556 7.06342C2.175 7.06342 0 8.76163 0 11.5973C0 16.0191 6.12223 15.3141 6.12223 17.2206C6.12223 17.9576 5.47778 18.1979 4.57556 18.1979C3.23834 18.1979 1.53056 17.6532 0.177222 16.9162V20.7292C1.67556 21.37 3.19 21.6424 4.57556 21.6424C7.92667 21.6424 10.2306 19.9922 10.2306 17.1245C10.2145 12.3503 4.07612 13.1994 4.07612 11.4051Z",
    fill: "#635BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeIcon);
export default __webpack_public_path__ + "static/media/stripe-icon.96e736abc78005ea559ef4b1215cf962.svg";
export { ForwardRef as ReactComponent };